import { ActionReducerMap } from '@ngrx/store';
import { LoginState } from '../login/login.models';
import { loginReducer } from '../login/login.reducer';

export interface AppState {
  login?: LoginState;
}

export const reducers: ActionReducerMap<AppState> = {
  login: loginReducer,
};
